export default {
  __TRANSLATE_START__: '',
  Registration_LoginWith: 'Войти с',
  Registration_TooltipCoralId: 'Coral ID — ваш клубный номер',
  Registration_YourCoralId: 'Ваш Coral ID',
  Registration_Password: 'Пароль',
  Registration_FillTheField: 'Заполните поле',
  Registration_WrongLoginOrPass: 'Неверный логин или пароль',
  Registration_ForgotPassword: 'Забыли пароль?',
  Registration_Login: 'Войти',
  Registration_Or: 'или',
  Registration_ToRegister: 'Зарегистрироваться',
  Registration_HaveClubNumberButNoAccount: 'Есть клубный номер, но нет аккаунта?',
  Registration_GetPassword: 'Получить пароль',
  Registration_ForgotYourCoralId: 'Забыли Coral ID?',
  Registration_HaveYouCoralID: 'Уже есть Coral ID?',
  Registration_Reg: 'Регистрация',
  Registration_Continue: 'Продолжить',
  Registration_EnterCorrectEmail: 'Введите корректный email',
  Registration_EnterCoralIDandEmail: 'Введите Coral ID и email',
  Registration_EnterEmailYouWant: 'Укажите email и Coral ID',
  Registration_YourEmail: 'Email',
  Registration_Phone: 'Телефон',
  Registration_ActivationCoralID: 'Активация Coral ID',
  Registration_CreateAccount: 'Создать аккаунт',
  Registration_RecoveryPassword: 'Восстановление пароля',
  Registration_EnterYourNewPassword: 'Введите новый пароль',
  Registration_ConfirmYourNewPassword: 'Повторите пароль',
  Registration_PasswordsDoNotMatch: 'Пароли не совпадают',
  Registration_Confirm: 'Подтвердить',
  Registration_UsersNotExists: 'Пользователь не найден',
  Registration_MakeSurePassword: 'Убедитесь, что пароль:',
  Registration_6symbols: 'Содержит не менее 6 символов',
  Registration_LeastOneNumber: 'Содержит хотя бы одну цифру или спецсимвол',
  Registration_SuccessfulReg: 'Регистрация прошла успешно!',
  Registration_CandidateRegistered: 'Кандидат зарегистрирован!',
  Registration_FindOnEmail: 'Данные отправлены на',
  Registration_UseForLogin: 'Используйте их для входа',
  Registration_DataSentOnEmailCandidate: 'Данные отправлены кандидату на',
  Registration_SentForConfirmationEmail: 'Мы отправили письмо для подтверждения email',
  Registration_EnterEmailAfterDub: 'Введите email, указанный при регистрации',
  Registration_Description: 'Авторизация и регистрация Coral Club',
  Registration_LinkSent: 'Письмо отправлено',
  Registration_CheckEmail: 'Проверьте почту и перейдите по ссылке',
  Registration_PasswordChanged: 'Пароль успешно изменён',
  Registration_AlreadyRegistered: 'Аккаунт уже активирован',
  Registration_GoToLogin: 'Перейти ко входу',
  Registration_Name: 'Имя',
  Registration_Surname: 'Фамилия',
  Registration_Patronymic: 'Отчество',
  Registration_Otchestvo: 'Отчество',
  Registration_Birthdate: 'Дата рождения',
  Registration_EnterCorrectBirthdate: 'Введите корректную дату рождения',
  Registration_Gender: 'Пол',
  Registration_GenderM: 'Мужской',
  Registration_GenderF: 'Женский',
  Registration_GenderMale: 'Мужской',
  Registration_GenderFemale: 'Женский',
  Registration_ChooseGender: 'Необходимо выбрать пол',
  latin_only_russian_error:
    'Имя и фамилия должны быть заполнены латиницей',
  latin_cyrillic_only_error:
    'Имя и фамилия должны быть заполнены кириллицей или латиницей',
  LOGIN_META_TITLE: 'Вход в личный кабинет Coral Club',
  LOGIN_META_DESCRIPTION:
    'Авторизация в личном кабинете Coral Club. Войдите по Coral ID и паролю.',
  REGISTRATION_META_TITLE: 'Регистрация в Coral Club',
  REGISTRATION_META_DESCRIPTION:
    'Станьте членом клуба Coral Club. Заполните форму регистрации.',
  Registration_GoToCatalog: 'Перейти в каталог',
  Registration_ContinueShopping: 'Продолжить покупки',
  Registration_GoToBasket: 'Перейти в корзину',
  Registration_Checkout: 'Оформить заказ',
  Registration_PasswordSuccessfullyRecovered: 'Пароль успешно восстановлен!',
  Registration_UseItToLogIntoYourAccount: 'Используйте его для входа в аккаунт',
  Registration_AlmostReady: 'Почти готово!',
  Registration_WeSentALink_1: 'Мы выслали на вашу почту ',
  Registration_WeSentALink_2:
    ' ссылку на восстановление пароля. Перейдите по ней, чтобы ввести новый пароль.',
  Registration_WeSentALinkActivation_2:
    'Мы отправили ссылку для активации аккаунта. Перейдите по ней, чтобы завершить регистрацию.',
  Registration_YouAreAlreadyRegistered:
    'Вы уже зарегистрированы онлайн. Мы отправили ссылку для восстановления доступа на',
  Registration_ChooseCountryInSelector: 'Страна',
  Registration_CountryInSelectorNotFounded: 'Страна не найдена',
  Registration_Country: 'Страна',
  Registration_City: 'Город',
  Registration_YourCity: 'Ваш город',
  Registration_InputCityName: 'Введите название города',
  Registration_CityIsnotInYourCountry: 'Город не найден в выбранной стране',
  Registration_Invitation: 'Приглашение',
  Registration_InvitedToCoral: 'Вас пригласили в Coral Club?',
  Registration_WereYouInvited: 'Вас пригласили в Coral Club?',
  Registration_YES: 'Да',
  Registration_NO: 'Нет',
  Registration_Yes: 'Да',
  Registration_No: 'Нет',
  Registration_ConsultantId: 'Coral ID консультанта',
  Registration_CoralID: 'Coral ID',
  Registration_ConsultantPhone: 'Телефон консультанта',
  Registration_ConsultantNotFound: 'Консультант не найден',
  Registration_ByInvitation: 'Вас пригласил',
  Registration_YouConsultant: 'Ваш консультант',
  Registration_ConsultantWillIntroduce: 'Он поможет вам познакомиться с продуктами и бизнесом',
  Registration_Language: 'Язык',
  Registration_LanguageRequire: 'Язык общения',
  Registration_SelectLanguage: 'Выберите язык',
  FIND: 'Найти',
  wrong_phone: 'Неверный номер телефона',
  number_must_start_from_2: 'Номер должен начинаться с 2',
  number_must_start_from_7: 'Номер должен начинаться с 7',
  Registration_Agreements: 'Соглашения',
  Registration_AgreeWith: 'Я согласен с',
  Registration_RegRules: 'Правилами регистрации',
  Registration_SiteUse: 'Условиями использования сайта',
  Registration_PersDataPolicy: 'Политикой обработки персональных данных.',
  Registration_subscribe_agree:
    'Я согласен на получение рекламных и новостных писем',
  registration_processing_data:
    "Даю согласие на <a href='/faq/personalinformation/' class='text-accentColor font-medium' target='_blank'>обработку персональных данных</a>",
  Registration_ContinueRegVerify: 'Продолжить регистрацию',
  Registration_RestoreAccessVerify: 'Восстановить доступ',
  Registration_InputChangesVerify: 'Изменить данные',
  Registration_BackToCatalog: 'В каталог',
  Registration_BackHome: 'На главную',
  Registration_ToMain: 'На главную',
  Registration_ToPersonalAccount: 'В личный кабинет',
  Registration_EmailSuccessfullyConfirmed: 'Ваш E-mail успешно подтвержден!',
  Registration_ConfirmedYourAddress: 'Вы подтвердили ваш адрес',
  Registration_YouWillReceiveInfo:
    'Теперь вы будете получать на него информацию о заказах, все важные новости, персональные промокоды и акции.',
  Registration_BackToBasket: 'В корзину',
  Registration_BackToProduct: 'К товару',
  Registration_BackToPersonal: 'В личный кабинет',
  Registration_Simple_LegalPrefix:
    'Нажимая на «Стать членом клуба», я подтверждаю, что мне исполнилось 18 лет, и соглашаюсь с',
  Registration_Simple_NetworkError:
    'Проблемы с интернетом. Проверьте подключение и попробуйте позже',
  Registration_Simple_ProcessingRequired:
    'Подтвердите согласие на обработку персональных данных',
  Registration_Simple_SuccessTitle: 'Теперь вы член клуба CoralClub',
  Registration_Simple_SuccessHint:
    'Отправили клубный номер вам на почту — добавьте это письмо в Избранное, чтобы не потерять',
  Registration_Simple_StartShopping: 'Начать покупки',
  Registration_Simple_Cancel: 'Отмена',
  Registration_Simple_DubTitle: 'Нашли ваш аккаунт с клубным номером',
  Registration_Simple_DubHint:
    'Похоже, у вас уже есть аккаунт. Выберите, что хотите сделать дальше',
  Registration_Simple_DubLogin: 'Войти в существующий аккаунт',
  Registration_Simple_DubLoginHint:
    'Сохранятся структура, накопленные бонусы и история заказов',
  Registration_Simple_DubChangeReferrer: 'Сменить рекомендателя',
  Registration_Simple_DubChangeReferrerHint:
    'Поможем подобрать нового рекомендателя и перейти в другую структуру',
  Registration_Simple_DubCreateNew: 'Создать новый аккаунт',
  Registration_Simple_DubCreateNewHint:
    'После создания нового аккаунта текущий будет удалён',
  Registration_Simple_ConfirmTitle: 'Создать новый аккаунт?',
  Registration_Simple_ConfirmText:
    'Мы удалим ваш старый аккаунт — клубный номер, история заказов и накопленные бонусы будут утеряны',
  Registration_Simple_ConfirmWarning:
    'После удаления аккаунт восстановить не получится',
  __TRANSLATE_END__: '',
}
